/* eslint-disable */

const flags = {
    'Австралия': 'Flag_of_Australia.svg?ver=1',
    'Австрия': 'Flag_of_Austria.svg?ver=1',
    'Азербайджан': 'Flag_of_Azerbaijan.svg?ver=1',
    'Албания': 'Flag_of_Albania.svg?ver=1',
    'Андорра': 'Flag_of_Andorra.svg?ver=1',
    'Аргентина': 'Flag_of_Argentina.svg?ver=1',
    'Армения': 'Flag_of_Armenia.svg?ver=1',
    'Белоруссия': 'Flag_of_Belarus.svg?ver=1',
    'Беларусь': 'Flag_of_Belarus.svg?ver=1',
    'Бельгия': 'Flag_of_Belgium.svg?ver=1',
    'Бермуды': 'Flag_of_Bermuda.svg?ver=1',
    'Болгария': 'Flag_of_Bulgaria.svg?ver=1',
    'Боливия': 'Flag_of_Bolivia.svg?ver=1',
    'Босния и Герцеговина': 'Flag_of_Bosnia_and_Herzegovina.svg?ver=1',
    'Бразилия': 'Flag_of_Brazil.svg?ver=1',
    'Великобритания': 'Flag_of_the_United_Kingdom.svg?ver=1',
    'Венгрия': 'Flag_of_Hungary.svg?ver=1',
    'Восточный Тимор': 'Flag_of_East_Timor.svg?ver=1',
    'Гана': 'Flag_of_Ghana.svg?ver=1',
    'Германия': 'Flag_of_Germany.svg?ver=1',
    'Гонконг': 'Flag_of_Hong_Kong.svg?ver=1',
    'Греция': 'Flag_of_Greece.svg?ver=1',
    'Грузия': 'Flag_of_Georgia.svg?ver=1',
    'Дания': 'Flag_of_Denmark.svg?ver=1',
    'Израиль': 'Flag_of_Israel.svg?ver=1',
    'Индия': 'Flag_of_India.svg?ver=1',
    'Иран': 'Flag_of_Iran.svg?ver=1',
    'Ирландия': 'Flag_of_Ireland.svg?ver=1',
    'Исландия': 'Flag_of_Iceland.svg?ver=1',
    'Испания': 'Flag_of_Spain.svg?ver=1',
    'Италия': 'Flag_of_Italy.svg?ver=1',
    'Казахстан': 'Flag_of_Kazakhstan.svg?ver=1',
    'Канада': 'Flag_of_Canada.svg?ver=1',
    'Кения': 'Flag_of_Kenya.svg?ver=1',
    'Кипр': 'Flag_of_Cyprus.svg?ver=1',
    'Киргизия': 'Flag_of_Kyrgyzstan.svg?ver=1',
    'Китай': 'Flag_of_China.svg?ver=1',
    'КНДР': 'Flag_of_North_Korea.svg?ver=1',
    'Южная Корея': 'Flag_of_South_Korea.svg?ver=1',
    'Корея': 'Flag_of_United_Korea.svg?ver=1',
    'Колумбия': 'Flag_of_Colombia.svg?ver=1',
    'Косово': 'Flag_of_Kosovo.svg?ver=1',
    'Латвия': 'Flag_of_Latvia.svg?ver=1',
    'Ливан': 'Flag_of_Lebanon.svg?ver=1',
    'Литва': 'Flag_of_Lithuania.svg?ver=1',
    'Лихтенштейн': 'Flag_of_Liechtenstein.svg?ver=1',
    'Люксембург': 'Flag_of_Luxembourg.svg?ver=1',
    'Мадагаскар': 'Flag_of_Madagascar.svg?ver=1',
    'Македония': 'Flag_of_Macedonia.svg?ver=1',
    'Малайзия': 'Flag_of_Malaysia.svg?ver=1',
    'Мальта': 'Flag_of_Malta.svg?ver=1',
    'Марокко': 'Flag_of_Morocco.svg?ver=1',
    'Мексика': 'Flag_of_Mexico.svg?ver=1',
    'Молдавия': 'Flag_of_Moldova.svg?ver=1',
    'Монако': 'Flag_of_Monaco.svg?ver=1',
    'Монголия': 'Flag_of_Mongolia.svg?ver=1',
    'Нигерия': 'Flag_of_Nigeria.svg?ver=1',
    'Нидерланды': 'Flag_of_the_Netherlands.svg?ver=1',
    'Новая Зеландия': 'Flag_of_New_Zealand.svg?ver=1',
    'Норвегия': 'Flag_of_Norway.svg?ver=1',
    'ОСР': 'Olympic_flag.svg?ver=1',
    'Пакистан': 'Flag_of_Pakistan.svg?ver=1',
    'Польша': 'Flag_of_Poland.svg?ver=1',
    'Португалия': 'Flag_of_Portugal.svg?ver=1',
    'Пуэрто-Рико': 'Flag_of_Puerto_Rico.svg?ver=1',
    'Румыния': 'Flag_of_Romania.svg?ver=1',
    'Россия': 'Flag_of_Russia.svg?ver=1',
    'Сан-Марино': 'Flag_of_San_Marino.svg?ver=1',
    'Сербия': 'Flag_of_Serbia.svg?ver=1',
    'Сингапур': 'Flag_of_Singapore.svg?ver=1',
    'Словакия': 'Flag_of_Slovakia.svg?ver=1',
    'Словения': 'Flag_of_Slovenia.svg?ver=1',
    'США': 'Flag_of_the_United_States.svg?ver=1',
    'Таиланд': 'Flag_of_Thailand.svg?ver=1',
    'Тайвань': 'Flag_of_Chinese_Taipei.svg?ver=1',
    'Того': 'Flag_of_Togo.svg?ver=1',
    'Турция': 'Flag_of_Turkey.svg?ver=1',
    'Узбекистан': 'Flag_of_Uzbekistan.svg?ver=1',
    'Украина': 'Flag_of_Ukraine.svg?ver=1',
    'Филиппины': 'Flag_of_the_Philippines.svg?ver=1',
    'Финляндия': 'Flag_of_Finland.svg?ver=1',
    'Франция': 'Flag_of_France.svg?ver=1',
    'Хорватия': 'Flag_of_Croatia.svg?ver=1',
    'Черногория': 'Flag_of_Montenegro.svg?ver=1',
    'Чехия': 'Flag_of_the_Czech_Republic.svg?ver=1',
    'Чили': 'Flag_of_Chile.svg?ver=1',
    'Швейцария': 'Flag_of_Switzerland.svg?ver=1',
    'Швеция': 'Flag_of_Sweden.svg?ver=1',
    'Эквадор': 'Flag_of_Ecuador.svg?ver=1',
    'Эритрея': 'Flag_of_Eritrea.svg?ver=1',
    'Эстония': 'Flag_of_Estonia.svg?ver=1',
    'ЮАР': 'Flag_of_South_Africa.svg?ver=1',
    'Ямайка': 'Flag_of_Jamaica.svg?ver=1',
    'Япония': 'Flag_of_Japan.svg?ver=1',
    'Бермудские острова': 'Flag_of_Bermuda.svg?ver=1',
    'Доминика': 'Flag_of_DR.svg?ver=1',
    'Перу': 'Flag_of_Peru.svg?ver=1',
};

export default flags;



// WEBPACK FOOTER //
// ./src/static-data/flags.js